import apiClient from '../client/api';

export enum UserLevelType {
  waitlist = 'waitlist',
  user = 'user',
  member = 'member',
  canceled = 'canceled',
  admin = 'admin',
}

export type GetMeResponse = {
  profile: {
    id: string;
    name: string;
  } | null;
  account: {
    credential: string;
    id: string;
  };
  membership: {
    id: string;
    status: string;
    type: string;
    price: {
      amount: number;
      currency: string;
    };
    renewalDate: string;
    cancelAtPeriodEnd: boolean;
    paymentMethod: {
      id: string;
      type: string;
      billingDetails: {
        name: string;
        email: string;
        phone: string;
        address: {
          city: string;
          country: string;
          line1: string;
          line2: string;
          postalCode: string;
          state: string;
        };
      };
      brand: string;
      last4: string;
      country: string;
      funding: string;
      expiration: object;
    };
  };
  userLevel: UserLevelType;
  intercomUserHash: string;
};

async function get(): Promise<GetMeResponse | null> {
  const response = await apiClient.get('/me');

  return response.data;
}

export default { get };
